import React from 'react';
import {routeName} from '../../Service/env';
class Index extends React.Component{
    componentWillMount(){
        this.props.history.push(`/${routeName}`);
    }
    render(){
        return null;
    }
}
export default Index;